import "./../../styles/Reviews.css";

const ReviewTable = ({
    reviews,
    loading,
    onView,
    onApprove,
    onHide,
    onRestore,
    onDelete,
}) => {

    if (loading) {
        return <h3>Loading Reviews...</h3>;
    }

    if (!reviews.length) {
        return <h3>No Reviews Found</h3>;
    }

    return (
        <table className="review-table">

            <thead>
                <tr>
                    <th>Customer</th>
                    <th>Food</th>
                    <th>Provider</th>
                    <th>Rating</th>
                    <th>Status</th>
                    <th>Created</th>
                    <th>Actions</th>
                </tr>
            </thead>

            <tbody>

                {reviews.map((review) => (

                    <tr key={review._id}>

                        <td>
                            {review.customer?.name || "-"}
                        </td>

                        <td>
                            {review.food?.foodName || "-"}
                        </td>

                        <td>
                            {review.provider?.businessName || "-"}
                        </td>

                        <td>
                            ⭐ {review.rating}
                        </td>

                        <td>
                            {review.status}
                        </td>

                        <td>
                            {new Date(
                                review.createdAt
                            ).toLocaleDateString()}
                        </td>

                        <td className="review-actions">

                            <button
                                onClick={() =>
                                    onView(review._id)
                                }
                            >
                                View
                            </button>

                            <button
                                onClick={() =>
                                    onApprove(review._id)
                                }
                            >
                                Approve
                            </button>

                            <button
                                onClick={() =>
                                    onHide(review._id)
                                }
                            >
                                Hide
                            </button>

                            <button
                                onClick={() =>
                                    onRestore(review._id)
                                }
                            >
                                Restore
                            </button>

                            <button
                                onClick={() =>
                                    onDelete(review._id)
                                }
                            >
                                Delete
                            </button>

                        </td>

                    </tr>

                ))}

            </tbody>

        </table>
    );
};

export default ReviewTable;